module.exports = __webpack_public_path__ + "static/media/a9.1cd9f426.pdf";